import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/system';
import { useState } from 'react';

function Layout () {

  const [theme, setTheme] = useState(localStorage.getItem('theme')||'');
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? '': 'dark');
    localStorage.setItem('theme', theme ? '' : 'dark');
  }

  return (
      <main className={`${theme}`}>  
        <Header value={toggleTheme} theme={`${theme}`}/>
          <Container>
            <Outlet />
          </Container>
        <Footer />
      </main>
    );
  }
  
  export default Layout;